document.querySelector('.start-chat').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.live-chat-activator').click();
});
